import { DatenauswertungGenerisch } from '../../bereiche/datenauswertung/DatenauswertungGenerisch';
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';
import * as React from 'react';

interface VersionshistorieExportProps extends React.ClassAttributes<any> {
    data: any;
    setJSXdirect?: (content: JSX.Element) => void;
    setRenderButton: (button: JSX.Element) => void;
}

export class VersionshistorieExport extends React.Component<VersionshistorieExportProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getConfig(): any {
        const headers = [
            ['Titel', 1], ['Beschreibung', 3.5], ['Kürzel\nAnforderung', 0.75], ['Zielversion', 0.5], ['Datum', 0.5],
            ['Interne ID\n(CL-Liste)', 0.5], ['Interne Ticket-ID\n(Jira)', 0.75], ['Bereich', 0.5]
        ];
        const numCols = 8;
        const baseWidth = 100 / numCols;
        const values = this.getValues();

        return {
            titel1: 'Versionshistorie',
            filename: 'Versionshistorie.pdf',
            baseWidth: baseWidth,
            header: {
                blocks: headers.map((item: any[]) => ({
                    label: item[0] || null,
                    width: `${(+item[1] || 1) * baseWidth}%`,
                    customStyle: { minHeight: 15 }
                }))
            },
            rows: values.rows,
            rows_width: headers.map((item: any[]) => (+item[1] || 1) * baseWidth)
        };
    }

    getValues(): any {
        const data: any[] = (this.props.data || {})[IDs.ENT_VERSIONSHISTORIE] || [];
        const rows: any[] = [];

        data.forEach((item: any) => {
            const datum: string = item.datum ? Moment.unix(item.datum).format('DD.MM.YYYY') : null;
            rows.push([
                item.name || null, item.beschreibung || null, item.anforderung || null, item.zielversion || null, datum,
                item.liste_id || null, item.jira_id || null, item.bereich || null
            ]);
        });

        return { rows };
    }

    render(): JSX.Element {
        return (
            <DatenauswertungGenerisch
                config={this.getConfig()}
                orientation='landscape'
                setJSXdirect={this.props.setJSXdirect}
                setRenderButton={(renderButton: JSX.Element) => this.props.setRenderButton(renderButton)}
            />
        );
    }
}
